import { backfaceFixed } from './backfaceFixed';

export default function spMenu() {
  /**
   * スマホ用メニュー
   */
  (function ($) {
    function isFacebookAppForSpMenu() {
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    }

    let scrollPosition;
    //iOS（iPadOSを含む）かどうかのUA判定
    var ua = window.navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

    //bodyのスクロール固定
    async function bodyFixedOn() {
      // 現在のスクロール位置を取得
      scrollPosition = $(window).scrollTop();

      /**
       * トップページの場合はメインビジュアルを考慮した処理を追加する
       */
      if ($('body').hasClass('home')) {
        // ヘッダーの上部からの距離を取得
        let headerTop = $('#site-header').offset().top;

        // スクロール量がメインビジュアルを超えていない場合
        let preScrollPosition = headerTop;

        // ログインしている場合
        if (jQuery('body').hasClass('admin-bar')) {
          preScrollPosition -= jQuery('#wpadminbar').innerHeight();
        }

        // スクロール量がヘッダーに達していない場合
        if (scrollPosition < headerTop) {
          scrollPosition = headerTop;

          // ヘッダーバーまでスクロール
          await jQuery('html, body').animate({
            scrollTop: preScrollPosition
          }, 500, 'swing').promise();
        }
      }

      // ヘッダーを固定化
      $("#site-header-wrapper").addClass("js-is-sticky");
      $("#site-inner").addClass("js-is-sticky");
      $("#mobile-menu").addClass("js-is-opened");

      // iOS, Androidの場合
      // TODO: 通常はoverflow: hiddenのみでOK？
      $('html').css('height', '100vh');
      $('body').css('position', 'fixed');
      $('body').css('overflow', 'hidden');
      $('body').css('inset', '0px');
      $('body').css('top', '-' + scrollPosition + 'px');
    }

    //bodyのスクロール固定を解除
    function bodyFixedOff() {
      $(window).scrollTop(scrollPosition);
      $('html').css('height', '100%');
      $('body').css('position', '');
      $('body').css('top', '');
      $('body').css('overflow', '');

      if (!isFacebookAppForSpMenu()) {
        $("#mobile-menu").removeClass("js-is-opened");
      }

      // 解除時はヘッダーはsticky状態なのでクラスを削除しない
    }

    // スマホメニューを開く
    $('#js-menu-toggle').on('click', function () {
      // 開く
      if (!$(this).hasClass('js-is-open')) {
        // bodyとヘッダーを固定する
        bodyFixedOn();

        // メニューボタンの開くアニメーション
        $(this).addClass('js-is-open');

        // メニューを開く
        $('#mobile-menu').addClass('js-is-show');
      }
      // 閉じる
      else {
        // bodyとヘッダーの固定解除
        bodyFixedOff();

        // メニューボタンの閉じるアニメーション
        $(this).removeClass('js-is-open');

        // メニューを閉じる
        $('#mobile-menu').removeClass('js-is-show');
      }
    });

    /**
     * ヘッダーの固定、スクロールで表示・非表示。
     * body固定からの解除時にposition: stickyからfixedに変更するとヘッダーバーがチラつくため、sticky動作をJSから行う。
     */
    let headerWrapper = document.getElementById("site-header-wrapper");
    let siteInner = document.getElementById("site-inner");

    // TODO: 上下スクロールでヘッダーを隠す場合にコメント解除
    // let forceHideElement = document.getElementById("service");
    // var forceHidePos = forceHideElement.getBoundingClientRect().top;

    let startPos = 0;

    const spMenuControlHeightElm = document.getElementById('control-height');
    const spMenuAddressBarHeight = Math.abs(window.innerHeight - spMenuControlHeightElm.clientHeight);

    // トップページでのみ実行
    if (document.body.classList.contains('home')) {
      window.addEventListener("scroll", e => {
        // モーダルメニューが開かれているなら処理をしない
        if ($('#js-menu-toggle').hasClass('js-is-open')) return;

        let scrollPos = window.scrollY;

        // TODO: 上下スクロールでヘッダーを隠す場合にコメント解除
        // 下スクロールの場合
        // if (scrollPos >= startPos) {
        //   // スクロール量がヘッダーに到達しているなら
        //   if (scrollPos >= window.innerHeight) {
        //     // ただし、強制的に隠す要素に入ったらヘッダーを隠す
        //     if (scrollPos > forceHidePos) {
        //       // header.classList.add('js-is-hide');
        //     }
        //   }
        // }
        // // 上スクロールの場合
        // else {
        //   // ヘッダーを表示する
        //   // header.classList.remove('js-is-hide');

        //   // スクロール量がヘッダーに到達していないなら
        //   if (scrollPos < window.innerHeight) {
        //   }
        // }

        var windowHeight = document.documentElement.clientHeight;
        if (isFacebookAppForSpMenu()) {
          windowHeight = window.screen.height;
        }

        if (scrollPos >= windowHeight + spMenuAddressBarHeight) {
          // ヘッダーを固定する
          headerWrapper.classList.add('js-is-sticky');
          siteInner.classList.add('js-is-sticky');
        } else {
          // ヘッダーを固定解除する
          headerWrapper.classList.remove('js-is-sticky');
          siteInner.classList.remove('js-is-sticky');
        }

        startPos = scrollPos;
      });
    }
  })(jQuery);
}
